import jQuery from 'jquery';
import whatInput from 'what-input';
import Foundation from 'foundation-sites';
import site from './site'
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

jQuery( function() {
    site();
});
